import type { ActivationLifecycle } from '@/infra/activation'
import { LifecycleTracker } from '@/infra/lifecycle-tracker'
import { computed } from 'mobx'
import type { JobWidgetStore } from '@/features/jobs/job-widget/JobWidgetStore'
import { task } from 'mobx-task'

export class JobWidgetViewModel implements ActivationLifecycle {
  private readonly _lifecycle = new LifecycleTracker()

  @computed
  get jobWidget() {
    return this._jobWidgetStore.jobWidget
  }

  @computed get isLoading() {
    return this._fetchJob.pending
  }

  constructor(private readonly _jobWidgetStore: JobWidgetStore) {
    this._lifecycle.manage(this._jobWidgetStore.jobWidgetEvents$)
  }

  async activate(): Promise<void> {
    this._lifecycle.activate()
    const signal = this._lifecycle.signal
    await this._fetchJob(signal)
  }

  deactivate(): void {
    this._lifecycle.deactivate()
  }

  private _fetchJob = task(async (signal: AbortSignal) => {
    await this._jobWidgetStore.fetchJob(signal)
  })
}
